"use client";

import axiosInstance from "../config";
import {
  decryptObject,
  encryptObject,
  generateNonce,
} from "@/helpers/noncehelper";
const axios: any = axiosInstance();
const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;


export const addMealPlan = async (encryptedPayload: any) => {
  try {
    const { token, type, meal_type_id, recipe_ids, schedule_date } =
      decryptObject(encryptedPayload) as any;

    const body: any = {};

    body.type = type;
    body.meal_type_id = meal_type_id;
    body.recipe_ids = recipe_ids;
    body.schedule_date = schedule_date;

    const response = await axios.post("/mealplan", encryptObject(body), {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${encryptObject({ encrypt: crypto.randomUUID() }).toUpperCase()}`,
        focus: `${token}`,
        "x-nonce-token": generateNonce(),
        "x-user-timezone": timeZone,
      },
    });
    return response?.data || [];
  } catch (error: any) {
    console.log("Error: in api", error?.response?.data);
  }
};

export const getMealPlanRecipes = async (encryptedPayload: any) => {
  try {
    const { token, start_date, end_date, recipe_id } = decryptObject(
      encryptedPayload
    ) as any;

    const params: any = {
      start_date,
      end_date,
    };

    if (recipe_id) {
      params.recipe_id = recipe_id;
    }
    const response = await axios.get("/mealplan", {
      params,
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${encryptObject({ encrypt: crypto.randomUUID() }).toUpperCase()}`,
        focus: `${token}`,
        "x-nonce-token": generateNonce(),
        "x-user-timezone": timeZone,
      },
    });
    return response?.data || [];
  } catch (error: any) {
    console.log("Error: in api", error?.response?.data);
  }
};

export const updateMealPlan = async (encryptedPayload: any) => {
  try {
    const { token, type, meal_plan_id, schedule_date } = decryptObject(
      encryptedPayload
    ) as any;

    const body: any = {};

    body.type = type;
    body.meal_plan_id = meal_plan_id;
    body.schedule_date = schedule_date;

    const response = await axios.post("/mealplan", encryptObject(body), {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${encryptObject({ encrypt: crypto.randomUUID() }).toUpperCase()}`,
        focus: `${token}`,
        "x-nonce-token": generateNonce(),
        "x-user-timezone": timeZone,
      },
    });

    return response?.data || [];
  } catch (error: any) {
    console.log("Error: in api", error?.response?.data);
  }
};

export const deleteMealPlan = async (payload: any) => {
  try {
    const { meal_plan_ids, token } = payload;
    const response = await axios.delete("/mealplan", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${encryptObject({ encrypt: crypto.randomUUID() }).toUpperCase()}`,
        focus: `${token}`,
        "x-nonce-token": generateNonce(),
      },
      data: encryptObject({
        meal_plan_ids: meal_plan_ids,
      }),
    });
    return response?.data;
  } catch (error: any) {
    console.log("Error: in api", error?.response?.data);
  }
};
